<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-layout row mb-4>
          <v-flex shrink>
            <v-layout v-if="loadingStats">
              <v-flex>
                <v-progress-linear indeterminate>
                </v-progress-linear>
              </v-flex>
            </v-layout>
            <v-layout v-else row wrap justify-space-between align-content-space-between fill-height class="info-listing">
              <v-flex class="mr-4">
                <span>Shift Count:</span> {{ workHistoryStatsPaged.shiftCount }}
              </v-flex>
              <v-flex class="mr-4">
                <span>Hours in this query:</span> {{ formatStringAsDecimal(hourSum) }}
              </v-flex>
              <v-flex class="mr-4">
                <span>Hours This Week:</span> {{ formatDecimal(workHistoryStatsPaged.thisWeekHours) }}
              </v-flex>
              <!-- <v-flex class="mr-4">
                <span>Avg Rating:</span> {{ workHistoryStatsPaged.averageRating }}
              </v-flex> -->
              <v-flex class="mr-4">
                <span>Avg Weekly Hours (YTD):</span> {{ formatDecimal(workHistoryStatsPaged.averageWeekHoursYTD) }}
              </v-flex>
              <v-flex class="mr-4">
                <span>Avg Weekly Hours (L12):</span> {{ formatDecimal(workHistoryStatsPaged.averageWeekHoursL12) }}
              </v-flex>
            </v-layout>

            <v-layout v-if="false" row wrap justify-space-between align-content-space-between fill-height class="info-listing">
              <v-flex class="mr-4">
                <span>Shifts for this location:</span> {{ queryTotal }}
              </v-flex>
              <v-flex class="mr-4">
                <!-- TODO: need full stats for this -->
                <!-- <span>Total hours:</span> {{ this.locationHoursWorked.toFixed(2) }} -->
              </v-flex>
            </v-layout>
          </v-flex>

          <!--
          <v-flex grow>
            <v-btn block disabled>
              <v-icon left>folder</v-icon>
              Reviews Report
            </v-btn>
            <v-btn block disabled>
              <v-icon left>folder</v-icon>
              Attendance
            </v-btn>
          </v-flex>
          -->
        </v-layout>

        <v-layout align-center justify-space-between>
          <v-flex shrink class="mr-1">
            <v-autocomplete
              v-model="locationFilter"
              :items="filters.locations"
              item-text="name"
              item-value="id"
              label="Location"
              return-object
              clearable
            >
            </v-autocomplete>
          </v-flex>
          <v-flex shrink class="mr-5">
            <v-switch
              v-model="includeAbsent"
              label="Include Absent"
            />
          </v-flex>
          <v-flex>
            <v-switch
              v-model="onlyAbsent"
              label="Only Absent"
            />
          </v-flex>
        </v-layout>

        <v-card
          class="pb-2"
        >
        <v-data-table
          :headers="headers"
          :items="workHistoryPaged"
          :pagination.sync="pagination"
          :total-items="queryTotal"
          :loading="loading"
          hide-actions
        >
          <template slot="items" slot-scope="{ item }">
            <td>
              {{ formatDateTime(item.startDatetime, "MM/DD/YY") }}
            </td>
            <td>
              <router-link :to="{ name: 'worksiteShow', params: { worksiteId: item.worksiteId } }">
                {{ item.location }}
              </router-link>
            </td>
            <td>
              {{ formatDateTime(item.clockInTime, "h:mma") }}
            </td>
            <td>
              {{ formatDateTime(item.clockOutTime, "h:mma") }}
            </td>
            <td>
              {{ formatStringAsDecimal(item.hoursWorked) }}
            </td>
            <td>
              {{ formatDecimal(item.diff) }}
            </td>
            <td>
              <router-link
                :to="{ name: 'shift/sar', params: { shiftId: item.id } }"
              >SAR
              </router-link>
            </td>
            <td>
              <v-icon small v-if="item.employeeAbsent" color="warning" slot="activator">
                warning
              </v-icon>
            </td>
          </template>
        </v-data-table>
        <v-layout row align-center class="pa-2">
          <v-flex grow>
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
          </v-flex>
          <v-flex shrink>
            <v-select label="Rows per page" v-model="limit" :items="[10, 20, 50, 100]"></v-select>
          </v-flex>
        </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
  },
  created: function() {
    this.setUp()
  },
  props: [
    'employee'
  ],

  watch: {
    pagination(val) {
      if (val.sortBy === 'startDatetime') {
        this.dateSortOrder = 'shift_start_desc'
        if (val.descending) {
          this.dateSortOrder = 'shift_start_desc'
        } else {
          this.dateSortOrder = 'shift_start_asc'
        }
        this.getRecords()
      }

      if (val.sortBy === 'hoursWorked') {
        this.hoursWorkedSortOrder = 'hours_worked_desc'
        if (val.descending) {
          console.log('desc')
          this.dateSortOrder = 'hours_worked_desc'
        } else {
          console.log('asc')
          this.dateSortOrder = 'hours_worked_asc'
        }
        this.getRecords()
      }
    },
    page() {
      this.getRecords()
    },
    limit() {
      this.getRecords()
    },
    locationFilter() {
      this.getRecords()
    },

    onlyAbsent(val) {
      if (val) {
        this.includeAbsent = true
      }
      this.getRecords()
    },
    includeAbsent(val) {
      if (!val) {
        this.onlyAbsent = false
      }
      this.getRecords()
    },
  },

  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    ...mapState('hr', [
      'filters',
      'workHistory',
      'workHistoryPaged'
      // 'workHistoryStatsPaged',
    ]),
    page: {
      get() {
        return this.pagination.page
      },
      set(val) {
        this.pagination.page = val
      }
    },
    limit: {
      get() {
        return this.pagination.rowsPerPage
      },
      set(val) {
        this.pagination.rowsPerPage = val
      }
    },
    pages() {
      if (this.limit == null ||
        this.queryTotal == null
      ) return 0
      return Math.ceil(this.queryTotal / this.pagination.rowsPerPage)
    },
    computedOffset() {
      return this.limit * (this.page - 1) || 0
    },
    pageLength() {
      return Math.ceil(this.queryTotal / this.limit)
    },
    formattedQuery() {
      return {
        user_id: this.employee.id,
        location_id: this.locationFilter ? this.locationFilter.id : null,
        limit: this.limit,
        offset: this.computedOffset,
        only_absent: this.onlyAbsent,
        include_absent: this.includeAbsent,
        page: this.page,
        date_order: this.dateSortOrder,
      }
    },

    filteredWorkHistory: function () {
      let filtered = this.workHistory

      if (this.includeAbsent) {
        filtered = filtered.filter((shift) => {
          return shift
        })
      } else {
        filtered = filtered.filter((shift) => {
          if( !shift.employeeAbsent) {
            return shift
          }
        })
      }

      if (this.onlyAbsent) {
        filtered = filtered.filter((shift) => {
          if (shift.employeeAbsent) {
            return shift
          }
        })
      }

      if( this.locationFilter ) {
        filtered = filtered.filter((shift) => {
          if( shift.worksiteId == this.locationFilter.id ) {
            return shift
          }
        })
      }
      return filtered
    },
    // filteredWorkHistory: function () {
    //   return this.workHistory

    //   let filtered = []
    //   if( this.locationFilter ) {
    //     filtered = this.workHistory.filter((shift) => {
    //       if( shift.worksiteId == this.locationFilter.id ) {
    //         return shift
    //       }
    //     })
    //     return filtered
    //   }
    //   return this.workHistory
    // },
    locationShiftCount: function () {
      return this.workHistory.length
    },
    locationHoursWorked: function () {
      return this.workHistory.reduce((sum, shift) => sum + parseFloat(shift.hoursWorked), 0)
    }
  },
  data: function() {
    return {
      dateSortOrder: 'shift_start_desc',
      hoursWorkedSortOrder: 'hours_worked_desc',
      hourSum: 0,
      workHistoryStatsPaged: { shiftCount: 0, thisWeekHours: 0, averageWeekHoursYTD: 0, averageWeekHoursL12: 0 },
      includeAbsent: false,
      onlyAbsent: false,
      loading: true,
      loadingStats: false,
      locationFilter: '',
      queryTotal: 0,
      pagination: { rowsPerPage: 10, descending: true, page: 1 },
      filteredLocationID: null,
      headers: [
        {
          text: 'Date',
          value: 'startDatetime',
          sortDesc: true,
          sortable: true,
        },
        {
          text: 'Location',
          value: 'location',
          sortable: false,
        },
        {
          text: 'Start Time',
          value: 'clockInTime',
          sortable: false,
        },
        {
          text: 'End Time',
          value: 'clockOutTime',
          sortable: false,
        },
        {
          text: 'Hours Worked',
          value: 'hoursWorked',
          sortable: true,
        },
        {
          text: 'Diff',
          value: 'diff',
          sortable: false,
        },
        {
          text: '',
          value: '',
          sortable: false,
        }
      ],
    }
  },
  methods: {
    formatDateTime(value, format) {
      if (!value) return "";
      return this.$moment(value).format(format);
    },

    formatDecimal(number, precision = 2) {
      const num = parseFloat(number);
      if (isNaN(num)) return (0).toFixed(precision);
      return num.toFixed(precision);
    },

    formatStringAsDecimal (string, precision = 2) {
      const number = parseFloat(string);
      return this.formatDecimal(number, precision);
    },

    setUp () {
      this.$store.dispatch('hr/getFilters', this.user.id)
      // this.getToplineStats()
      this.getRecords()
    },

    // getToplineStats() {
    //   this.loadingStats = true
    //   this.$store.dispatch('hr/getStats', { userId: this.employee.id }).then((p) => {
    //   })
    //   .finally(() => {
    //     this.loadingStats = false
    //   })
    // },

    getRecords() {
      this.loading = true
      this.$store.dispatch('hr/getWorkHistoryPaged',
        this.formattedQuery
      ).then((p) => {
        this.workHistoryStatsPaged = p.stats
        this.queryTotal = p.totalItems
        this.hourSum = p.hourSum
      })
      .finally(() => {
        this.loading = false
      })
    },
  }

}
</script>
